<template>
	<div>
		<p class="upload-title">Upload img for slide {{ slide }}</p>
		<div>
			<div
				class="preview"
				v-if="previewBg"
				:style="{ 'background-image': `url(${previewBg})` }"
			></div>
			<div class="py-3">
				<label for="file-input" class="upload">
					<span class="btn btn-primary">{{
						file !== null || !previewBg ? 'Upload' : 'Replace' | translate
					}}</span>
					<input
						type="file"
						accept="image/*"
						@change="uploadPreview($event)"
						id="file-input"
					/>
				</label>
				<button
					v-if="previewBg"
					class="ml-3 btn btn-danger"
					@click="removeImage"
				>
					Remove
				</button>
			</div>
		</div>
		<b-modal
			hide-footer
			:visible="isSaved"
			@ok="closeModal"
			@hide="closeModal"
			:title="'Background image saved' | translate"
		>
		</b-modal>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'ConfigPuzzleImg',
	props: ['slide'],
	data() {
		return {
			isSaved: false,
			previewBg: null,
			file: null,
		}
	},
	methods: {
		closeModal() {
			this.isSaved = false
		},
		async saveImage() {
			let formData = new FormData()
			formData.append('image', this.file)
			const result = await axios({
				url: `storage/files/upload_puzzle_image/?slide=${this.slide}`,
				method: 'post',
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				data: formData,
			})
			if (result.status === 200 || result.status === 201) {
				this.isSaved = true
				this.file = null
				// window.location.reload()
			}
		},
		async uploadPreview(event) {
			const el = event.target

			if (
				el?.files[0].type != 'image/jpeg' &&
				el?.files[0].type != 'image/png'
			) {
				console.log('incorrect file format')

				return
			}

			if (el.files && el.files.length) {
				const file = el.files[0]
				const url = URL.createObjectURL(file)
				this.file = file
				this.previewBg = url
				await this.saveImage()
			}
		},
		async removeImage() {
			await this.deletePuzzleBg()
			this.previewBg = null
			this.file = null
		},
		async deletePuzzleBg() {
			const result = await axios({
				url: `storage/files/delete_puzzle_image/?slide=${this.slide}`,
				method: 'delete',
			})
		},
		async getPuzzleBg() {
			const result = await axios({
				url: `storage/files/download_puzzle_image/?slide=${this.slide}`,
				method: 'get',
			})
			if (result.status === 200 && result.data && result.data.link) {
				this.previewBg = result.data.link
			}
		},
	},
	mounted() {
		this.getPuzzleBg()
	},
}
</script>

<style scoped lang="scss">
.upload input[type='file'] {
	visibility: hidden;
	opacity: 0;
	position: absolute;
}

.upload-title {
	border-top: 1px solid #ddd;
	padding-top: 20px;
	color: var(--violet-color);
	font-size: 20px;
	font-weight: bold;
}

.preview {
	width: 400px;
	height: 300px;
	background-size: cover;
	max-width: 600px;
	overflow: hidden;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
</style>
